import React, { useContext, useState, useEffect } from 'react';
import UsuarioContext from '../../context/usuario.context';
import FirebaseContext from '../../context/firebase.context';
import PosicoesContext from '../../context/posicoes.context';
import CidadesContext from '../../context/cidades.context';
import LogoAgSafe from '../../assets/logo-navbar-white.png';
import './navbar-desktop.scss';
import './navbar-mobile.scss';
import { fetchLocations2 } from '../../services/apis';

function Navbar() {
  const [cidade, setCidade] = useState('');
  const [nome, setNome] = useState('');
  const {
    amountNotifications, usuario, usuario: { superUsuario, tipoDeCadastro },
  } = useContext(UsuarioContext);
  const { setActualLocation } = useContext(CidadesContext);
  const {
    cancelRecord, clearLast, temp, removeEmptyValues,
    enableIputHeader: { estado: estadoValid, cidade: cidadeValid, tipo: tipoValid },
  } = useContext(PosicoesContext);
  const {
    logado,
  } = useContext(FirebaseContext);

  useEffect(() => {
    setNome(usuario.nome || '');
  }, [usuario.nome]);

  function clickMenu() {
    let menu = document.querySelector('.barraOculta');
    try {
      if (menu && menu.classList.contains('barraOculta')) {
        menu.classList.remove('barraOculta');
        menu.classList.add('barraOcultaShow');
      } else {
        menu = document.querySelector('.barraOcultaShow');
        menu.classList.remove('barraOcultaShow');
        menu.classList.add('barraOculta');
      }
    } catch (error) {
      const menu1 = document.querySelector('.barraInvisivel');
      menu1.classList.remove('barraInvisivel');
      menu1.classList.add('barraOcultaShow');
    }
  }

  function optionsClick() {
    const sizePositions = temp.positions?.length || 0;
    let menu;
    if (temp.positions[0]?.lat !== 0 && sizePositions > 0) {
      if (document.querySelector('.bar-map')) {
        menu = document.querySelector('.bar-map');
        menu.classList.remove('bar-map');
        menu.classList.add('bar-map-in');
      }
    } else {
      try {
        menu = document.querySelector('.bar-map-in');
        menu.classList.remove('bar-map-in');
        menu.classList.add('bar-map-out');
        setTimeout(() => {
          menu = document.querySelector('.bar-map-out');
          menu.classList.remove('bar-map-out');
          menu.classList.add('bar-map');
        }, 1000);
      } catch (error) {
        if (!error.message) return null;
      }
    }
    return null;
  }

  function renderText() {
    if (temp.type === 'marker') {
      if (temp.positions[0] !== 0) {
        return 'Marcker posicionado';
      }
      return '0 posição marcada';
    }
    if (temp.positions.length > 1
      && (temp.positions[0]?.lat !== 0 && temp.positions[0]?.lng !== 0)) {
      return `${temp.positions.length} posições marcadas`;
    }
    if (temp.positions.length === 1
      && (temp.positions[0]?.lat !== 0 && temp.positions[0]?.lng !== 0)) {
      return `${temp.positions.length} posição marcada`;
    }
    if (temp.positions[0]?.lat !== 0 && temp.positions[0]?.lng !== 0) {
      return 'Marcker posicionado';
    }
    return '0 posição marcada';
  }

  useEffect(() => {
    optionsClick();
  }, [temp]);

  return (
    <>
      {(logado) && (
      <div id="navbar">
        <div className="barraInvisivel">
          {!superUsuario && (
          <div className="item-menu">
            <div className="content-menu-drop-icons">
              <i className="fas fa-user-circle" />
            </div>
            <div className="content-menu-drop-text">
              <button onClick={() => clickMenu()} data-toggle="modal" data-target="#modal-meus-dados" className="buttons-transparent" type="button">
                <span>Minha Conta</span>
              </button>
            </div>
          </div>
          )}
          {(!superUsuario && (tipoDeCadastro !== 'Coleta')) && (
          <div className="item-menu">
            <div className="content-menu-drop-icons">
              {temp.tipo !== 'Selecione' ? <i className="fas fa-forward" /> : <i className="fas fa-plus" />}
            </div>
            <div className="content-menu-drop-text">
              <button onClick={() => clickMenu()} data-toggle="modal" data-target="#modal-novo-cadastro" className="buttons-transparent" type="button">
                <span>
                  {
                    (estadoValid && cidadeValid && tipoValid) ? 'Continuar Cadastro' : 'Novo Cadastro'
                  }
                </span>
              </button>
            </div>
          </div>
          )}
          {(!superUsuario && (tipoDeCadastro !== 'Coleta'))
            && (
            <div className="item-menu">
              <div className="content-menu-drop-icons">
                <i className="fas fa-satellite" />
              </div>
              <div className="content-menu-drop-text">
                <button onClick={() => clickMenu()} data-toggle="modal" data-target="#modal-cadastros-ativos" className="buttons-transparent" type="button">
                  <span>Cadastros Ativos</span>
                </button>
              </div>
            </div>
            )}
          {superUsuario
            && (
            <div className="item-menu">
              <div className="content-menu-drop-icons">
                <i className="fas fa-satellite" />
              </div>
              <div className="content-menu-drop-text">
                <button onClick={() => clickMenu()} data-toggle="modal" data-target="#modal-cadastros-ativos-admin" className="buttons-transparent" type="button">
                  <span>Cadastros Ativos</span>
                </button>
              </div>
            </div>
            )}
          {superUsuario && (
            <>
              <div className="item-menu">
                <div className="content-menu-drop-icons">
                  <i className="fas fa-check-double" />
                </div>
                <div className="content-menu-drop-text">
                  <button onClick={() => clickMenu()} data-toggle="modal" data-target="#modal-cadastros-inativos-admin" className="buttons-transparent" type="button">
                    <span>Aprovar Cadastros</span>
                  </button>
                </div>
              </div>
              <div className="item-menu">
                <div className="content-menu-drop-icons">
                  <i className="fas fa-plus" />
                </div>
                <div className="content-menu-drop-text">
                  <button onClick={() => clickMenu()} data-toggle="modal" data-target="#modal-atribuir" className="buttons-transparent" type="button">
                    <span>Atribuir Cadastro</span>
                  </button>
                </div>
              </div>
              <div className="item-menu">
                <div className="content-menu-drop-icons">
                  <i className="fas fa-recycle" />
                </div>
                <div className="content-menu-drop-text">
                  <button onClick={() => clickMenu()} data-toggle="modal" data-target="#modal-novo-cadastro" className="buttons-transparent" type="button">
                    <span>
                      {
                    (estadoValid && cidadeValid && tipoValid) ? 'Continuar Cadastro' : 'Cadastrar Coleta'
                  }
                    </span>
                  </button>
                </div>
              </div>
              <div className="item-menu">
                <div className="content-menu-drop-icons">
                  <i className="fas fa-chalkboard-teacher" />
                </div>
                <div className="content-menu-drop-text">
                  <button onClick={() => clickMenu()} data-toggle="modal" data-target="#modal-apresentar" className="buttons-transparent" type="button">
                    <span>Apresentação</span>
                  </button>
                </div>
              </div>
              <div className="item-menu">
                <div className="content-menu-drop-icons">
                  <i className="far fa-paper-plane" />
                </div>
                <div className="content-menu-drop-text">
                  <button onClick={() => clickMenu()} data-toggle="modal" data-target="#modal-notificar" className="buttons-transparent" type="button">
                    <span>Notificar Usuários</span>
                  </button>
                </div>
              </div>
            </>
          )}
          <div className="item-menu">
            <div className="content-menu-drop-icons">
              <i className="fas fa-sign-out-alt" />
            </div>
            <div className="content-menu-drop-text">
              <button onClick={() => clickMenu()} data-toggle="modal" data-target="#modal-logout" className="buttons-transparent" type="button">
                <span>Fazer Logout</span>
              </button>
            </div>
          </div>
        </div>
        <div className="bar-map">
          <button onClick={() => console.log(temp)} className="buttons-transparent" type="button">
            <i className="fas fa-map-marker-alt">
              <span>
                {renderText()}
              </span>
            </i>
          </button>
          <button onClick={() => clearLast()} className="buttons-transparent" type="button">
            <i className="fas fa-undo">
              <span>Desfazer</span>
            </i>
          </button>
          <button onClick={cancelRecord} className="buttons-transparent" type="button">
            <i className="fas fa-ban">
              <span>Cancelar</span>
            </i>
          </button>
          <button data-toggle="modal" data-target="#modal-novo-cadastro" className="buttons-transparent" type="button">
            {/* <button onClick={()=>updateDate()}className="buttons-transparent" type="button"> */}
            <i className="fas fa-check-double">
              <span>Confirmar</span>
            </i>
          </button>
        </div>
        <div className="barraVisivel">
          <div className="navbar-left">
            <img src={LogoAgSafe} alt="Dominus Soli" />
          </div>
          <div className="navbar-right">
            {(tipoDeCadastro !== 'Coleta') && (
            <form autoComplete="off" className="input-search">
              <input
                onChange={(e) => setCidade(e.target.value)}
                type="text"
                value={cidade}
                name="fone"
                id="fone"
                required
                placeholder="Informe a cidade"
              />
              <button
                onClick={() => {
                  if (cidade.trim().length > 0) {
                    fetchLocations2(cidade, '').then(({ latitude, longitude }) => {
                      setActualLocation([latitude, longitude]);
                      setCidade('');
                    }).catch(() => {
                      setCidade('');
                    });
                  } else {
                    removeEmptyValues();
                  }
                }}
                type="button"
                className="buttons-transparent"
              >
                <i className="fas fa-search" />
              </button>
            </form>
            )}
            <div className="navbar-nome">
              <span data-toggle="modal" data-target="#modal-meus-dados">
                {`Olá ${nome.split(' ')[0] || ''}`}
              </span>
            </div>
            {!superUsuario && (
            <div className="navbar-notificacoes">
              {amountNotifications > 0
              && <span>{amountNotifications}</span>}
              <div className="navbar-bells">
                <button type="button" data-toggle="modal" data-target="#modal-mensagens" className="buttons-transparent">
                  {amountNotifications > 0
                    ? <i className="fas fa-bell show-notifications" />
                    : <i className="fas fa-bell" />}
                </button>
              </div>
            </div>
            )}
            <div className="navbar-menu">
              <button className="buttons-transparent" onClick={() => clickMenu()} type="button">
                <i className="fas fa-bars" />
              </button>
            </div>
          </div>
        </div>
      </div>
      )}
    </>

  );
}

export default Navbar;
